import { Record } from 'immutable';

const DashboardFilterStateRecord = Record({
  completedAndUnpaid: true,
  missingAgency: true

});

export class DashboardFilterState extends DashboardFilterStateRecord {
  completedAndUnpaid: boolean;
  missingAgency: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/dashboard/dashboard-page/dashboard-filter.ts